export function SeparatorView() {
  return <hr className="nsw-section-separator" />;
}
